// Trainer Studio i18n fallback
export default {
  "common.back": "Zurück",
  "common.cancel": "Abbrechen",
  "common.confirm": "Bestätigen",
  "common.create": "Erstellen",
  "common.delete": "Löschen",
  "common.edit": "Bearbeiten",
  "common.error": "Ein Fehler ist aufgetreten.",
  "common.loading": "Laden …",
  "common.save": "Speichern",
  "common.saving": "Speichere…",
  "trainer.app.subtitle": "Tennis-Matches.de",
  "trainer.app.tagline": "Training vorbereiten und Einheiten planen.",
  "trainer.app.title": "Trainer Studio",
  "trainer.billing.invoices.section.open": "Offene Rechnungen",
  "trainer.billing.invoices.section.paid": "Bezahlte Rechnungen",
  "trainer.billing.invoices.subtitle": "Verwalten Sie Ihre Rechnungen",
  "trainer.billing.invoices.title": "Rechnungen",
  "trainer.billing.overview.section.recent": "Letzte Transaktionen",
  "trainer.billing.overview.section.summary": "Zusammenfassung",
  "trainer.billing.overview.subtitle": "Übersicht über Ihre Abrechnungen",
  "trainer.billing.overview.title": "Abrechnung",
  "trainer.billing.rates.section.special": "Sonderpreise",
  "trainer.billing.rates.section.standard": "Standardpreise",
  "trainer.billing.rates.subtitle": "Verwalten Sie Ihre Preise und Sätze",
  "trainer.billing.rates.title": "Preise",
  "trainer.common.actions": "Aktionen",
  "trainer.common.confirmDelete": "Wirklich löschen?",
  "trainer.common.court": "Platz {n}",
  "trainer.common.minutes": "{count} Min",
  "trainer.common.durationRange": "{min}–{max} Min",
  "trainer.common.noData": "Keine Einträge",
  "trainer.common.saved": "Gespeichert.",
  "trainer.common.selectStudents": "Schüler auswählen",
  "trainer.common.students.one": "1 Schüler",
  "trainer.common.students.other": "{count} Schüler",
  "trainer.dashboard.empty.lessonPlans": "Noch keine Unterrichtspläne.",
  "trainer.dashboard.empty.sessions": "Noch keine Stunden geplant.",
  "trainer.dashboard.empty.createLessonPlan":
    "Ersten Unterrichtsplan erstellen",
  "trainer.dashboard.empty.openSessions": "Stunden öffnen",
  "trainer.dashboard.hero.kicker": "Deine nächste Einheit",
  "trainer.dashboard.hero.lead":
    "Pläne weiterbearbeiten oder neue Übungen entdecken.",
  "trainer.dashboard.cta.newLessonPlan": "+ Unterrichtsplan",
  "trainer.dashboard.drills.teaser": "Ideen für deine Trainingsplanung",
  "trainer.dashboard.drills.open": "Übungen entdecken",
  "trainer.dashboard.drills.title": "Übungsbibliothek",
  "trainer.dashboard.recentPlans.title": "Zuletzt bearbeitet",
  "trainer.dashboard.recentPlans.meta": "{level} · {duration} · {blocks}",
  "trainer.dashboard.section.upcoming": "Anstehende Stunden",
  "trainer.dashboard.nextWeek.days.di": "Di",
  "trainer.dashboard.nextWeek.days.do": "Do",
  "trainer.dashboard.nextWeek.days.fr": "Fr",
  "trainer.dashboard.nextWeek.days.mi": "Mi",
  "trainer.dashboard.nextWeek.days.mo": "Mo",
  "trainer.dashboard.nextWeek.sessions": "Sessions",
  "trainer.dashboard.nextWeek.title": "Nächste Woche",
  "trainer.dashboard.overview.greeting": "Guten Tag, {name}",
  "trainer.dashboard.overview.subtitle":
    "Hier ist dein Überblick für diese Woche",
  "trainer.dashboard.quickActions.billing": "Abrechnung",
  "trainer.dashboard.quickActions.createLesson": "Lesson erstellen",
  "trainer.dashboard.quickActions.findDrill": "Übung finden",
  "trainer.dashboard.quickActions.newSession": "Neue Session planen",
  "trainer.dashboard.quickActions.title": "Schnellzugriff",
  "trainer.dashboard.recentTemplates.all": "Alle",
  "trainer.dashboard.recentTemplates.title": "Letzte Vorlagen",
  "trainer.dashboard.sampleSessions.adultsAdvanced":
    "Erwachsene Fortgeschritten",
  "trainer.dashboard.sampleSessions.privateCoaching":
    "Einzel-Coaching M. Weber",
  "trainer.dashboard.sampleSessions.u14": "Jugend U14 Training",
  "trainer.dashboard.sampleTemplates.baselineBasics.meta": "90 Min - Anfänger",
  "trainer.dashboard.sampleTemplates.baselineBasics.title":
    "Grundlinienspiel Basics",
  "trainer.dashboard.sampleTemplates.kidsFun.meta": "60 Min - Kinder",
  "trainer.dashboard.sampleTemplates.kidsFun.title": "Kids Fun Tennis",
  "trainer.dashboard.sampleTemplates.serveIntensive.meta":
    "60 Min - Fortgeschritten",
  "trainer.dashboard.sampleTemplates.serveIntensive.title":
    "Aufschlag-Intensiv",
  "trainer.dashboard.section.recent": "Letzte Aktivitäten",
  "trainer.dashboard.section.stats": "Statistiken",
  "trainer.dashboard.section.upcoming": "Anstehende Trainerstunden",
  "trainer.dashboard.session.lessonAssigned": "Lesson zugewiesen",
  "trainer.dashboard.session.noLesson": "Keine Lesson",
  "trainer.dashboard.stats.activeStudents": "aktive Schüler",
  "trainer.dashboard.stats.hours": "Stunden",
  "trainer.dashboard.stats.hoursThisWeek": "Std. diese Woche",
  "trainer.dashboard.stats.lessonPlans": "Unterrichtspläne",
  "trainer.dashboard.stats.revenue": "Umsatz",
  "trainer.dashboard.stats.revenueThisMonth": "EUR diesen Monat",
  "trainer.dashboard.stats.sessions": "Sessions",
  "trainer.dashboard.stats.students": "Schüler",
  "trainer.dashboard.stats.thisWeek": "diese Woche",
  "trainer.dashboard.stats.upcomingSessions": "Anstehende Stunden",
  "trainer.dashboard.subtitle": "Training vorbereiten und Einheiten planen.",
  "trainer.dashboard.title": "Übersicht",
  "trainer.dashboard.today.allSessions": "Alle Sessions",
  "trainer.dashboard.today.title": "Heute",
  "trainer.drills.categories.all": "Alle",
  "trainer.drills.categories.aria": "Kategorien",
  "trainer.drills.categories.games": "Spiele",
  "trainer.drills.categories.section.list": "Kategorien",
  "trainer.drills.categories.subtitle":
    "Organisieren Sie Ihre Übungen nach Kategorien",
  "trainer.drills.categories.tactics": "Taktik",
  "trainer.drills.categories.technique": "Technik",
  "trainer.drills.categories.title": "Übungskategorien",
  "trainer.drills.categories.total": "Übungen gesamt",
  "trainer.drills.categories.count": "{count} Übungen",
  "trainer.drills.categories.gaps": "Tags ohne Übung",
  "trainer.drills.categories.gapsHint": "Rot markiert – noch keine Übung",
  "trainer.drills.categories.weak": "Tags mit wenig Abdeckung",
  "trainer.drills.categories.weakHint": "Gelb markiert – 1–4 Übungen",
  "trainer.drills.categories.levelSection": "Nach Level",
  "trainer.drills.categories.difficultySection": "Nach Schwierigkeit",
  "trainer.drills.categories.fillLevel": "Füllgrad gesamt",
  "trainer.drills.categories.fillLevelHint":
    "Ø aller {count} Pflichtfelder pro Übung",
  "trainer.drills.categories.fillPercent": "{percent} % vollständig",
  "trainer.drills.categories.fillSectionHint":
    "Klick öffnet die Kategorie: unvollständige Übungen, Heatmap (Level × Schwierigkeit) und Option für alle Übungen.",
  "trainer.drills.categories.detailSubtitle":
    "{count} Übungen · Füllgrad {percent} %",
  "trainer.drills.categories.incompleteList": "Unvollständige Übungen",
  "trainer.drills.categories.allList": "Alle Übungen",
  "trainer.drills.categories.viewIncomplete": "Unvollständig ({count})",
  "trainer.drills.categories.viewAll": "Alle ({count})",
  "trainer.drills.categories.openAllInList": "Alle in Übungsliste",
  "trainer.drills.categories.heatmapTitle": "Verteilung Level × Schwierigkeit",
  "trainer.drills.categories.heatmapOverallTitle":
    "Gesamtverteilung (Level × Schwierigkeit)",
  "trainer.drills.categories.heatmapOverviewHint":
    "Alle Übungen im Katalog. Klick öffnet die gefilterte Übungsliste.",
  "trainer.drills.categories.heatmapByCategoryTitle": "Heatmap pro Kategorie",
  "trainer.drills.categories.heatmapByCategoryHint":
    "Klick auf eine Zelle springt zur Kategorie mit passendem Filter.",
  "trainer.drills.categories.heatmapHint":
    "Zahl = Übungen in dieser Zelle, darunter Ø-Füllgrad. Klick filtert die Liste darunter.",
  "trainer.drills.categories.heatmapCorner": "Level \\ Schw.",
  "trainer.drills.categories.heatmapEmpty": "Keine Übungen",
  "trainer.drills.categories.heatmapCellTitle":
    "{count} Übungen · Ø {percent} % vollständig",
  "trainer.drills.categories.cellFill": "Ø {percent} %",
  "trainer.drills.categories.missingFields": "{count} Felder offen",
  "trainer.drills.categories.matrixFilterActive":
    "Filter: {level}, Schwierigkeit {difficulty}",
  "trainer.drills.categories.matrixFilterClear": "Filter aufheben",
  "trainer.drills.categories.listEmptyIncomplete":
    "Alle Übungen in dieser Kategorie sind gut gefüllt.",
  "trainer.drills.categories.listEmptyAll":
    "Keine Übungen in dieser Kategorie.",
  "trainer.drills.categories.notFound.title": "Kategorie nicht gefunden",
  "trainer.drills.categories.notFound.subtitle": 'Keine Kategorie "{id}".',
  "trainer.drills.categories.coverageHint":
    "Klick springt zur gefilterten Übungsliste.",
  "trainer.drills.categories.warmup": "Warm-up",
  "trainer.drills.detail.notFound.subtitle":
    'Keine Übung mit ID "{id}" gefunden.',
  "trainer.drills.detail.notFound.title": "Übung nicht gefunden",
  "trainer.drills.detail.section.coachingTips": "Coaching-Tipps",
  "trainer.drills.detail.section.description": "Beschreibung",
  "trainer.drills.detail.section.setup": "Aufbau",
  "trainer.drills.detail.section.similar": "Ähnliche Übungen",
  "trainer.drills.detail.section.usedInLessons": "Verwendet in Lessons",
  "trainer.drills.detail.section.variations": "Variationen",
  "trainer.drills.detail.section.videos": "Videos",
  "trainer.drills.media.sectionTitle": "Videos",
  "trainer.drills.media.empty": "Noch keine Videos hinterlegt.",
  "trainer.drills.media.addTitle": "YouTube-Video hinzufügen",
  "trainer.drills.media.addButton": "Video speichern",
  "trainer.drills.media.previewTitle": "Vorschau",
  "trainer.drills.media.embedTitle": "YouTube-Video",
  "trainer.drills.media.primaryBadge": "Hauptvideo",
  "trainer.drills.media.openOnYoutube": "Auf YouTube öffnen",
  "trainer.drills.media.consentNotice":
    "Dieses Video wird von YouTube geladen. Dabei können Daten an YouTube übertragen werden.",
  "trainer.drills.media.loadVideo": "Video laden",
  "trainer.drills.media.field.url": "YouTube-URL",
  "trainer.drills.media.field.title": "Titel",
  "trainer.drills.media.field.language": "Sprache",
  "trainer.drills.media.field.startSecond": "Startzeit (Sekunden)",
  "trainer.drills.media.field.adminNotes": "Interne Notizen",
  "trainer.drills.media.field.isPrimary": "Als Hauptvideo markieren",
  "trainer.drills.media.field.isActive": "Video aktiv",
  "trainer.drills.media.error.load": "Videos konnten nicht geladen werden.",
  "trainer.drills.media.error.schemaNotReady":
    "Video-Funktion ist in dieser Datenbank noch nicht aktiv (Migration drill_media fehlt).",
  "trainer.drills.media.error.save": "Video konnte nicht gespeichert werden.",
  "trainer.drills.media.error.delete": "Video konnte nicht gelöscht werden.",
  "trainer.drills.media.error.invalidUrl": "Ungültige YouTube-URL.",
  "trainer.drills.media.error.duplicate":
    "Dieses Video ist für die Übung bereits hinterlegt.",
  "trainer.drills.media.moveUp": "Video nach oben",
  "trainer.drills.media.moveDown": "Video nach unten",
  "trainer.drills.media.error.reorder":
    "Reihenfolge konnte nicht gespeichert werden.",
  "trainer.drills.media.search.title": "Videos für Übung suchen",
  "trainer.drills.media.search.hint":
    "Vorschläge basieren auf Titel, Metadaten und Trainingskontext. Auswahl wird erst nach Bestätigung gespeichert.",
  "trainer.drills.media.search.button": "YouTube-Vorschläge laden",
  "trainer.drills.media.search.notConfigured":
    "YouTube-Suche ist nicht konfiguriert (YOUTUBE_API_KEY fehlt).",
  "trainer.drills.media.search.queries": "Suchanfragen:",
  "trainer.drills.media.search.addOne": "Als Video hinzufügen",
  "trainer.drills.media.search.addSelected":
    "{count} ausgewählte Videos hinzufügen",
  "trainer.drills.media.search.error": "YouTube-Suche fehlgeschlagen.",
  "trainer.drills.media.search.forbidden":
    "YouTube-Suche ist nur für Superadmins verfügbar.",
  "trainer.drills.media.search.apiMissing":
    "API-Route nicht erreichbar. Bitte lokalen API-Server neu starten (pnpm dev:api).",
  "trainer.drills.media.coverage.title": "Video-Abdeckung im Repository",
  "trainer.drills.media.coverage.withVideo": "Übungen mit aktivem Video",
  "trainer.drills.media.coverage.withPrimary": "Übungen mit Hauptvideo",
  "trainer.drills.media.coverage.col.drills": "Übungen",
  "trainer.drills.media.coverage.col.video": "Mit Video",
  "trainer.drills.media.coverage.col.primary": "Mit Hauptvideo",
  "trainer.drills.media.coverage.error":
    "Video-Abdeckung konnte nicht geladen werden.",
  "trainer.drills.media.timeline.title": "Video-Verlauf",
  "trainer.drills.media.timeline.hint":
    "Oben: neu hinzugefügte Videos. Unten: von YouTube entfernte Videos (täglicher Scan).",
  "trainer.drills.media.timeline.added": "Hinzugefügt",
  "trainer.drills.media.timeline.removed": "Entfernt (YouTube)",
  "trainer.drills.media.timeline.addedCount": "{count} hinzugefügt",
  "trainer.drills.media.timeline.removedCount": "{count} entfernt",
  "trainer.drills.media.timeline.empty":
    "Noch keine Video-Ereignisse im gewählten Zeitraum.",
  "trainer.drills.media.timeline.error":
    "Video-Verlauf konnte nicht geladen werden.",
  "trainer.drills.media.timeline.aria":
    "Zeitlicher Verlauf von hinzugefügten und entfernten Übungsvideos",
  "trainer.drills.categories.videoAvailabilityHint":
    "Anteil der Repository-Übungen mit verlinktem YouTube-Video. Nicht mehr verfügbare Videos werden täglich automatisch entfernt.",
  "trainer.drills.detail.sidebar.addToLesson": "Zu Lesson hinzufügen",
  "trainer.drills.detail.sidebar.category": "Kategorie",
  "trainer.drills.detail.sidebar.duration": "Dauer",
  "trainer.drills.detail.sidebar.groupSize": "Spieleranzahl",
  "trainer.drills.detail.sidebar.level": "Level",
  "trainer.drills.detail.sidebar.title": "Details",
  "trainer.drills.detail.subtitle": "Ansicht und Bearbeitung der Übung",
  "trainer.drills.detail.subtitleEdit": "Übung bearbeiten",
  "trainer.drills.form.title": "Titel",
  "trainer.drills.form.description": "Beschreibung",
  "trainer.drills.form.groupSize": "Spieleranzahl",
  "trainer.drills.playerCounts.idealFor": "Ideal für {counts} Spieler",
  "trainer.drills.playerCounts.overFour": "> 4 Spieler",
  "trainer.drills.playerCounts.option": "{count} Spieler",
  "trainer.drills.playerCounts.overFourOption": "> 4 Spieler",
  "trainer.drills.playerCounts.hint":
    "Mehrfachauswahl: Für welche Spieleranzahlen ist die Übung ideal?",
  "trainer.drills.playerCounts.hintGames":
    "„> 4 Spieler“ ist vor allem für Mini-Spiele sinnvoll.",
  "trainer.drills.playerCounts.adaptationsTitle":
    "Anpassungen für mehr Spieler",
  "trainer.drills.playerCounts.adaptationFor": "Mit {count} Spielern",
  "trainer.drills.playerCounts.adaptationOverFour": "Mit > 4 Spielern",
  "trainer.drills.playerCounts.adaptationPlaceholder":
    "Optional: Wie ändert sich die Variante?",
  "trainer.drills.form.variations": "Variationen",
  "trainer.drills.form.variationsHint":
    "Jede Variante einzeln – in der Stundenplanung optional als Vorschlag markierbar.",
  "trainer.drills.variation.badge": "Variante {n}",
  "trainer.drills.variation.option": "Variante {n}: {label}",
  "trainer.drills.variation.add": "Variante hinzufügen",
  "trainer.drills.variation.remove": "Entfernen",
  "trainer.drills.variation.empty": "Noch keine Varianten.",
  "trainer.drills.form.coachingTips": "Coaching-Tipps (eine pro Zeile)",
  "trainer.drills.form.durationMin": "Dauer min (Min.)",
  "trainer.drills.form.durationMax": "Dauer max (Min.)",
  "trainer.drills.form.category": "Kategorie",
  "trainer.drills.form.level": "Level",
  "trainer.drills.form.difficulty": "Schwierigkeit",
  "trainer.drills.detail.title": "Übung Details",
  "trainer.drills.items.1.description":
    "Konstante Cross-Court Rally mit Fokus auf Länge und Kontrolle.",
  "trainer.drills.items.1.duration": "10–15 Min",
  "trainer.drills.items.1.groupSize": "2–4 Spieler",
  "trainer.drills.items.1.tip.1": "Hohe Trefferquote vor Tempo.",
  "trainer.drills.items.1.tip.2": "Früh treffen, stabiler Stand.",
  "trainer.drills.items.1.title": "Cross-Court Rally",
  "trainer.drills.items.1.variation.1":
    "Zielzonen markieren und nur in die Zone zählen.",
  "trainer.drills.items.1.variation.2":
    "Nach 5 Schlägen Richtung wechseln (Vorhand/Rückhand).",
  "trainer.drills.items.2.description":
    "Aufschlagpräzision mit Zielzonen (T, Körper, außen).",
  "trainer.drills.items.2.duration": "10 Min",
  "trainer.drills.items.2.groupSize": "1–6 Spieler",
  "trainer.drills.items.2.tip.1": "Routinen konstant halten.",
  "trainer.drills.items.2.tip.2": "Klarer Zielpunkt – nicht „irgendwo hin“.",
  "trainer.drills.items.2.title": "Aufschlag-Zielscheibe",
  "trainer.drills.items.2.variation.1": "Punkte für Treffer (z.B. 3/2/1).",
  "trainer.drills.items.2.variation.2": "Nur 2. Aufschlag (Kick/Slice).",
  "trainer.drills.items.10.description":
    "Kurzer Wettbewerb mit Aufgaben (z.B. 3 Returns in Folge).",
  "trainer.drills.items.10.duration": "10 Min",
  "trainer.drills.items.10.groupSize": "4–8 Spieler",
  "trainer.drills.items.10.tip.1": "Ziele klar und messbar formulieren.",
  "trainer.drills.items.10.tip.2": "Motivation durch kleine Rewards.",
  "trainer.drills.items.10.title": "Punkte-Jagd",
  "trainer.drills.items.10.variation.1": "Teams bilden und addieren.",
  "trainer.drills.items.10.variation.2": "Zusatzpunkte für Netzangriffe.",
  "trainer.drills.items.11.description":
    "Slice als Approach-Shot und anschließender Volley.",
  "trainer.drills.items.11.duration": "12 Min",
  "trainer.drills.items.11.groupSize": "2–4 Spieler",
  "trainer.drills.items.11.tip.1": "Slice flach halten.",
  "trainer.drills.items.11.tip.2":
    "Nach dem Schlag Richtung Netz beschleunigen.",
  "trainer.drills.items.11.title": "Slice Approach",
  "trainer.drills.items.11.variation.1": "Approach nur auf Rückhandseite.",
  "trainer.drills.items.11.variation.2": "Volley auf freie Ecke abschließen.",
  "trainer.drills.items.12.description":
    "Passier- und Lob-Entscheidung gegen Netzspieler trainieren.",
  "trainer.drills.items.12.duration": "15 Min",
  "trainer.drills.items.12.groupSize": "2 Spieler",
  "trainer.drills.items.12.tip.1": "Schulter früh drehen – Blick auf Lücke.",
  "trainer.drills.items.12.tip.2": "Tempo vs. Winkel bewusst wählen.",
  "trainer.drills.items.12.title": "Passierschlag Training",
  "trainer.drills.items.12.variation.1":
    "Netzspieler startet näher am Netz (Druck).",
  "trainer.drills.items.12.variation.2":
    "Nur 1 Passierschlag erlaubt – dann Punkt frei.",
  "trainer.drills.items.4.description":
    "Angriff über Slice/Approach + erster Volley gezielt platzieren.",
  "trainer.drills.items.4.duration": "15 Min",
  "trainer.drills.items.4.groupSize": "2–4 Spieler",
  "trainer.drills.items.4.tip.1": "Nach dem Approach sofort nachrücken.",
  "trainer.drills.items.4.tip.2": "Erster Volley ist der wichtigste Volley.",
  "trainer.drills.items.4.title": "Netz-Angriff Muster",
  "trainer.drills.items.4.variation.1":
    "Approach nur cross, Volley nur longline.",
  "trainer.drills.items.4.variation.2":
    "Mit Passier-/Lob-Entscheidung für den Gegner.",
  "trainer.drills.items.5.description":
    "Return-Position und Gegenangriff nach dem Return trainieren.",
  "trainer.drills.items.5.duration": "12 Min",
  "trainer.drills.items.5.groupSize": "2 Spieler",
  "trainer.drills.items.5.tip.1": "Split-Step vor dem Return.",
  "trainer.drills.items.5.tip.2": "Früh entscheiden: Block oder Zug.",
  "trainer.drills.items.5.title": "Return & Counter",
  "trainer.drills.items.5.variation.1": "Nur Returns cross, dann freies Spiel.",
  "trainer.drills.items.5.variation.2":
    "Return aggressiv vs. sicher im Wechsel.",
  "trainer.drills.items.6.description":
    "Bewegungsmuster und Absprachen im Doppel (I-Formation/klassisch).",
  "trainer.drills.items.6.duration": "15 Min",
  "trainer.drills.items.6.groupSize": "4 Spieler",
  "trainer.drills.items.6.tip.1": "Kommunikation vor dem Punkt.",
  "trainer.drills.items.6.tip.2": "Lücken schließen – nicht schauen.",
  "trainer.drills.items.6.title": "Doppel-Formation",
  "trainer.drills.items.6.variation.1": "Nur Aufschlag + erster Ball.",
  "trainer.drills.items.6.variation.2": "Signal-System vor jedem Punkt nutzen.",
  "trainer.drills.items.7.description":
    "Koordination und Fußarbeit als Warm-up (Skippings, Sidesteps).",
  "trainer.drills.items.7.duration": "8 Min",
  "trainer.drills.items.7.groupSize": "2–8 Spieler",
  "trainer.drills.items.7.tip.1": "Saubere Technik vor Tempo.",
  "trainer.drills.items.7.tip.2": "Kurze Kontakte – aktive Füße.",
  "trainer.drills.items.7.title": "Lauf-ABC",
  "trainer.drills.items.7.variation.1": "Mit Ball in der Hand (Koordination).",
  "trainer.drills.items.7.variation.2":
    "Mit kurzen Sprints am Ende jeder Bahn.",
  "trainer.drills.items.8.description":
    "Gefühl und Ballkontrolle im Servicefeld (kurz-kurz).",
  "trainer.drills.items.8.duration": "5 Min",
  "trainer.drills.items.8.groupSize": "2–8 Spieler",
  "trainer.drills.items.8.tip.1": "Lockere Hand, weicher Arm.",
  "trainer.drills.items.8.tip.2": "Treffpunkt vor dem Körper.",
  "trainer.drills.items.8.title": "Mini-Tennis",
  "trainer.drills.items.8.variation.1": "Nur Slice erlaubt.",
  "trainer.drills.items.8.variation.2":
    "Punkt nur, wenn Ball nach 2. Sprung hinter Service-Linie landet.",
  "trainer.drills.items.9.description":
    "Wettbewerbsformat: Gewinner bleibt, Herausforderer rotiert.",
  "trainer.drills.items.9.duration": "15 Min",
  "trainer.drills.items.9.groupSize": "4–8 Spieler",
  "trainer.drills.items.9.tip.1": "Klare Regeln vor Start.",
  "trainer.drills.items.9.tip.2": "Kurze Pausen – hohe Intensität.",
  "trainer.drills.items.9.title": "King of the Court",
  "trainer.drills.items.9.variation.1": "Nur 1 Ballwechsel pro Punkt.",
  "trainer.drills.items.9.variation.2": "Bonuspunkt für Winner longline.",
  "trainer.drills.list.difficulty": "Schwierigkeit",
  "trainer.drills.list.results.one": "{count} Übung gefunden",
  "trainer.drills.list.results.other": "{count} Übungen gefunden",
  "trainer.drills.list.searchPlaceholder": "Übung suchen…",
  "trainer.drills.list.section.all": "Alle Übungen",
  "trainer.drills.list.section.favorites": "Favoriten",
  "trainer.drills.list.subtitle": "Verwalten Sie Ihre Übungen",
  "trainer.drills.list.tags": "Tags",
  "trainer.drills.list.title": "Übungen",
  "trainer.drills.import.placeholder": "",
  "trainer.drills.import.title": "Massenupload",
  "trainer.drills.import.subtitle":
    "Excel-Datei hochladen oder JSON importieren",
  "trainer.drills.import.schema.title": "Felder für ChatGPT / Excel",
  "trainer.drills.import.schema.hint":
    "Lade die Excel-Vorlage herunter, fülle eine Zeile pro Übung aus. Listen (Tags, Variationen, Tipps) mit Semikolon trennen.",
  "trainer.drills.import.schema.listSep": "Semikolon-getrennt, z. B. „A; B; C“",
  "trainer.drills.import.schema.field": "Feld",
  "trainer.drills.import.schema.required": "Pflicht",
  "trainer.drills.import.schema.type": "Typ",
  "trainer.drills.import.schema.values": "Erlaubte Werte",
  "trainer.drills.import.schema.requiredYes": "Ja",
  "trainer.drills.import.schema.requiredNo": "Nein",
  "trainer.drills.import.schema.categories":
    "technique | tactics | warmup | games",
  "trainer.drills.import.schema.levels":
    "all | beginner | intermediate | advanced | prof",
  "trainer.drills.import.schema.difficulty": "1 (leicht) – 4 (schwer)",
  "trainer.drills.import.field.title": "title – Titel der Übung",
  "trainer.drills.import.field.category": "category – Kategorie",
  "trainer.drills.import.field.level": "level – Spielniveau",
  "trainer.drills.import.field.difficulty": "difficulty – Schwierigkeit",
  "trainer.drills.import.field.idealPlayerCounts":
    "idealPlayerCounts – Spieleranzahlen 1–4 (Semikolon, z. B. „2;3;4“)",
  "trainer.drills.import.field.idealOverFour":
    "idealOverFour – auch > 4 Spieler (true/false, primär Mini-Spiele)",
  "trainer.drills.import.field.groupSize":
    "groupSize – Legacy-Freitext (wird in Zahlen umgewandelt, z. B. „2–4 Spieler“)",
  "trainer.drills.import.field.durationMinutesMin":
    "durationMinutesMin – Mindestdauer in Minuten (Planungsvorschlag)",
  "trainer.drills.import.field.durationMinutesMax":
    "durationMinutesMax – Höchstdauer in Minuten",
  "trainer.drills.import.field.description": "description – Beschreibung",
  "trainer.drills.import.field.tags": "tags – Schlagwörter (Array, optional)",
  "trainer.drills.import.field.variations":
    "variations – Variationen (Array, optional)",
  "trainer.drills.import.field.coachingTips":
    "coachingTips – Coaching-Tipps (Array, optional)",
  "trainer.drills.import.example.title": "Beispiel-JSON (optional)",
  "trainer.drills.import.excel.title": "Excel-Upload",
  "trainer.drills.import.excel.hint":
    "Erste Zeile = Spaltenüberschriften (wie in der Vorlage). Ab Zeile 2 die Übungen.",
  "trainer.drills.import.excel.template": "Excel-Vorlage herunterladen",
  "trainer.drills.import.excel.file": "Excel-Datei wählen (.xlsx)",
  "trainer.drills.import.excel.fileSelected": "Datei: {name}",
  "trainer.drills.import.paste.title": "Alternativ: JSON einfügen",
  "trainer.drills.import.paste.placeholder": '[{ "title": "…", … }]',
  "trainer.drills.import.file.label": "JSON-Datei wählen",
  "trainer.drills.import.validate": "Prüfen",
  "trainer.drills.import.import": "Importieren",
  "trainer.drills.import.preview.title": "Vorschau",
  "trainer.drills.import.preview.count": "{count} Übungen bereit",
  "trainer.drills.import.success": "{count} Übungen importiert.",
  "trainer.drills.import.partial":
    "{created} importiert, {failed} fehlgeschlagen.",
  "trainer.drills.import.error.excel-empty": "Excel enthält keine Datenzeilen.",
  "trainer.drills.import.error.excel-no-sheet":
    "Excel enthält kein Tabellenblatt.",
  "trainer.drills.import.error.excel-invalid":
    "Excel-Datei konnte nicht gelesen werden.",
  "trainer.drills.import.error.json-invalid": "Ungültiges JSON.",
  "trainer.drills.import.error.json-not-array": "JSON muss ein Array sein.",
  "trainer.drills.import.error.json-empty": "Array ist leer.",
  "trainer.drills.import.error.validation":
    "Zeile {row}, Feld „{field}“: {code}",
  "trainer.drills.import.error.code.title-required": "Titel fehlt",
  "trainer.drills.import.error.code.category-invalid": "Kategorie ungültig",
  "trainer.drills.import.error.code.level-invalid": "Level ungültig",
  "trainer.drills.import.error.code.difficulty-invalid":
    "Schwierigkeit muss 1–4 sein",
  "trainer.drills.import.error.code.idealPlayerCounts-required":
    "Spieleranzahl fehlt",
  "trainer.drills.import.error.code.duration-min-invalid":
    "Mindestdauer ungültig (1–240)",
  "trainer.drills.import.error.code.duration-max-invalid":
    "Höchstdauer ungültig (1–240)",
  "trainer.drills.import.error.code.duration-range-invalid":
    "Mindestdauer darf nicht größer als Höchstdauer sein",
  "trainer.drills.import.error.code.description-required": "Beschreibung fehlt",
  "trainer.drills.import.open": "Massenupload",
  "trainer.drills.tags.title": "Repository-Abdeckung",
  "trainer.drills.tags.subtitle":
    "Globale Ziel-KPIs für Schläge, Schlagart und Schwerpunkte im Übungs-Repository.",
  "trainer.drills.tags.openOverview": "Repository-Abdeckung anzeigen",
  "trainer.drills.metadata.title": "Trainings-Metadaten",
  "trainer.drills.metadata.subtitle":
    "Dimensionen und Items des Übungs-Wissensmodells (nur Superadmin).",
  "trainer.drills.metadata.forbidden": "Nur für Superadmin zugänglich.",
  "trainer.drills.metadata.dimensions.title": "Dimensionen",
  "trainer.drills.metadata.col.key": "Key",
  "trainer.drills.metadata.col.label": "Label",
  "trainer.drills.metadata.col.labelDe": "Label (de-DE)",
  "trainer.drills.metadata.col.cardinality": "Kardinalität",
  "trainer.drills.metadata.col.sort": "Sort.",
  "trainer.drills.metadata.col.active": "Aktiv",
  "trainer.drills.metadata.col.items": "Items",
  "trainer.drills.metadata.empty.items": "Keine Items",
  "trainer.drills.metadata.error.load":
    "Metadaten konnten nicht geladen werden.",
  "trainer.drills.metadata.error.save": "Speichern fehlgeschlagen.",
  "trainer.drills.metadata.success.save": "Gespeichert.",
  "trainer.drills.tags.searchPlaceholder": "Aspekt suchen …",
  "trainer.drills.tags.hint":
    "Klick auf einen Aspekt filtert die Übungsliste. Farben zeigen die Abdeckung: rot = keine Übung, gelb = 1–4, grün = 5+.",
  "trainer.drills.tags.metadataFallback":
    "Metadaten aus dem lokalen Katalog – DB-Sync steht noch aus.",
  "trainer.drills.tags.section.stroke": "Schläge",
  "trainer.drills.tags.section.style": "Schlagart",
  "trainer.drills.tags.section.focus": "Schwerpunkte",
  "trainer.drills.form.tags": "Technik-Aspekte",
  "trainer.drills.tags.results": "{count} Aspekte",
  "trainer.drills.tags.empty": "Keine Aspekte für diese Filter.",
  "trainer.drills.tags.avgFill": "Ø Füllgrad {percent} %",
  "trainer.drills.tags.noDrills": "Keine Übungen",
  "trainer.drills.tags.stats.total": "Aspekte gesamt",
  "trainer.drills.tags.stats.good": "Gut abgedeckt",
  "trainer.drills.tags.stats.goodHint": "5+ Übungen",
  "trainer.drills.tags.stats.weak": "Schwach abgedeckt",
  "trainer.drills.tags.stats.gaps": "Lücken",
  "trainer.drills.tags.stats.gapsHint": "Noch keine Übung",
  "trainer.drills.tags.filter.aria": "Abdeckungsfilter",
  "trainer.drills.tags.filter.all": "Alle",
  "trainer.drills.tags.filter.gaps": "Lücken",
  "trainer.drills.tags.filter.weak": "Schwach",
  "trainer.drills.tags.filter.good": "Gut",
  "trainer.drills.tags.attack": "Angriff",
  "trainer.drills.tags.backhand": "Rückhand",
  "trainer.drills.tags.baseline": "Grundlinie",
  "trainer.drills.tags.competition": "Wettbewerb",
  "trainer.drills.tags.coordination": "Koordination",
  "trainer.drills.tags.doubles": "Doppel",
  "trainer.drills.tags.feel": "Gefühl",
  "trainer.drills.tags.footwork": "Beinarbeit",
  "trainer.drills.tags.forehand": "Vorhand",
  "trainer.drills.tags.formation": "Formation",
  "trainer.drills.tags.fun": "Spaß",
  "trainer.drills.tags.motivation": "Motivation",
  "trainer.drills.tags.netPlay": "Netzspiel",
  "trainer.drills.tags.passingShot": "Passierschlag",
  "trainer.drills.tags.positioning": "Positionierung",
  "trainer.drills.tags.precision": "Präzision",
  "trainer.drills.tags.reaction": "Reaktion",
  "trainer.drills.tags.return": "Return",
  "trainer.drills.tags.serve": "Aufschlag",
  "trainer.drills.tags.slice": "Slice",
  "trainer.drills.tags.tactics": "Taktik",
  "trainer.drills.tags.volley": "Volley",
  "trainer.drills.tags.warmup": "Einspielen",
  "trainer.lessonPlans.detail.block.custom": "Eigener Block",
  "trainer.lessonPlans.detail.block.main1": "Hauptteil 1",
  "trainer.lessonPlans.detail.block.main2": "Hauptteil 2",
  "trainer.lessonPlans.detail.block.main3": "Hauptteil 3",
  "trainer.lessonPlans.detail.block.warmup": "Warm-up",
  "trainer.lessonPlans.detail.block.cooldown": "Cool-down",
  "trainer.lessonPlans.detail.edit": "Bearbeiten",
  "trainer.lessonPlans.edit.subtitle": "Blöcke, Übungen und Rahmen anpassen",
  "trainer.lessonPlans.detail.emptyBlocks": "Noch keine Blöcke.",
  "trainer.lessonPlans.detail.variationSuggested": "Vorschlag: {label}",
  "trainer.lessonPlans.new.form.variationsTitle": "Varianten",
  "trainer.lessonPlans.new.form.variationsHint":
    "Optional als Vorschlag markieren – finale Wahl erfolgt vor Ort.",
  "trainer.lessonPlans.new.form.variationOnSite": "Vor Ort entscheiden",
  "trainer.lessonPlans.new.form.variationSuggested": "Vorschlag",
  "trainer.lessonPlans.detail.focus.application": "Anwendung",
  "trainer.lessonPlans.detail.focus.technique": "Technik",
  "trainer.lessonPlans.detail.focus.tactics": "Taktik",
  "trainer.lessonPlans.detail.focus.conditioning": "Kondition",
  "trainer.lessonPlans.detail.focus.games": "Spiele",
  "trainer.lessonPlans.new.form.blockFocus": "Schwerpunkt",
  "trainer.lessonPlans.new.form.blockFocusHintWarmup": "Nur Warm-up-Übungen",
  "trainer.lessonPlans.new.form.blockFocusHintCooldown":
    "Nur Cool-down / leichte Übungen",
  "trainer.lessonPlans.new.form.drillFilteredEmpty": "Keine passenden Übungen",
  "trainer.lessonPlans.detail.method.deductive": "Deductiv",
  "trainer.lessonPlans.detail.method.inductive": "Inductiv",
  "trainer.lessonPlans.detail.section.drills": "Übungen",
  "trainer.lessonPlans.detail.section.info": "Informationen",
  "trainer.lessonPlans.detail.section.notes": "Notizen",
  "trainer.lessonPlans.detail.subtitle":
    "Ansicht und Bearbeitung des Unterrichtsplans",
  "trainer.lessonPlans.detail.summary.blocks": "Blöcke",
  "trainer.lessonPlans.detail.summary.duplicate": "Vorlage duplizieren",
  "trainer.lessonPlans.detail.summary.duration": "Stundenrahmen",
  "trainer.lessonPlans.detail.summary.blocksPlanned": "Geplante Übungszeit",
  "trainer.lessonPlans.detail.summary.level": "Level",
  "trainer.lessonPlans.detail.summary.methodology": "Methodik",
  "trainer.lessonPlans.detail.summary.title": "Zusammenfassung",
  "trainer.lessonPlans.detail.summary.used": "Verwendet",
  "trainer.lessonPlans.detail.summary.useForSession": "Für Session verwenden",
  "trainer.lessonPlans.detail.summary.usageScope": "Verwendung",
  "trainer.lessonPlans.form.usageScope.legend": "Verwendungszweck",
  "trainer.lessonPlans.form.usageScope.hint":
    "Wiederverwendbare Vorlagen kannst du mehrfach nutzen. Session-spezifische Pläne sind an konkrete Termine gedacht.",
  "trainer.lessonPlans.form.usageScope.reusable": "Wiederverwendbar",
  "trainer.lessonPlans.form.usageScope.reusableHint":
    "Als Vorlage für mehrere Trainings",
  "trainer.lessonPlans.form.usageScope.session": "Für eine Session",
  "trainer.lessonPlans.form.usageScope.sessionHint":
    "Konkret einem Termin zugeordnet",
  "trainer.lessonPlans.useForSession.title": "Für Session verwenden",
  "trainer.lessonPlans.useForSession.assignExistingHint":
    "Möchtest du den Plan einem bestehenden Training zuordnen?",
  "trainer.lessonPlans.useForSession.yesExisting":
    "Bestehendes Training wählen",
  "trainer.lessonPlans.useForSession.noExisting": "Nein, anders vorgehen",
  "trainer.lessonPlans.useForSession.pickSessionTitle": "Training auswählen",
  "trainer.lessonPlans.useForSession.assignConfirm": "Plan zuordnen",
  "trainer.lessonPlans.useForSession.noUpcomingSessions":
    "Keine geplanten Trainings ab heute gefunden.",
  "trainer.lessonPlans.useForSession.newChoiceTitle": "Wie weiter?",
  "trainer.lessonPlans.useForSession.newChoiceHint":
    "Als Vorlage bleibt der Plan in der Bibliothek. Bei konkreter Planung legst du einen Termin im TrainingsDesk an.",
  "trainer.lessonPlans.useForSession.keepTemplate": "Als Vorlage behalten",
  "trainer.lessonPlans.useForSession.planConcrete":
    "Konkret planen (TrainingsDesk)",
  "trainer.lessonPlans.useForSession.templateSaved":
    "Plan ist als wiederverwendbare Vorlage gespeichert.",
  "trainer.lessonPlans.detail.title": "Unterrichtsplan Details",
  "trainer.lessonPlans.list.blocks": "{count} Blöcke",
  "trainer.lessonPlans.list.filter.advanced": "Fortgeschritten",
  "trainer.lessonPlans.list.filter.all": "Alle",
  "trainer.lessonPlans.list.filter.beginner": "Anfänger",
  "trainer.lessonPlans.list.filter.kids": "Kinder",
  "trainer.lessonPlans.list.filter.tournament": "Turnierspieler",
  "trainer.lessonPlans.list.lastUsed": "Zuletzt verwendet: {label}",
  "trainer.lessonPlans.list.lastUsedDays": "vor {count} Tagen",
  "trainer.lessonPlans.list.open": "Öffnen",
  "trainer.lessonPlans.list.searchPlaceholder": "Vorlage suchen…",
  "trainer.lessonPlans.list.section.custom": "Eigene Pläne",
  "trainer.lessonPlans.list.section.templates": "Vorlagen",
  "trainer.lessonPlans.list.subtitle": "Verwalten Sie Ihre Unterrichtspläne",
  "trainer.lessonPlans.list.title": "Unterrichtsplanung",
  "trainer.lessonPlans.list.today": "heute",
  "trainer.lessonPlans.list.usedCount": "{count}x verwendet",
  "trainer.lessonPlans.new.form.addBlock": "Block hinzufügen",
  "trainer.lessonPlans.new.form.blockDuration": "Block-Dauer (Min.)",
  "trainer.lessonPlans.new.form.blockKey": "Block",
  "trainer.lessonPlans.new.form.blocks": "Blöcke",
  "trainer.lessonPlans.new.form.drill": "Übung",
  "trainer.lessonPlans.new.form.drillNone": "Keine Übung",
  "trainer.lessonPlans.new.form.drillOption":
    "{title} · Schwierigkeit {difficulty} · {duration}",
  "trainer.lessonPlans.new.form.duration": "Stundenrahmen (Min.)",
  "trainer.lessonPlans.new.form.drillDurationHint":
    "Vorschlag aus Übung: {duration} – Block-Dauer ist anpassbar",
  "trainer.lessonPlans.new.form.drillDurationHintCustom":
    "Individuell angepasst (Übungsvorschlag: {suggested})",
  "trainer.lessonPlans.new.durationSummary":
    "Geplante Übungszeit: {total} Min · Stundenrahmen: {target} Min",
  "trainer.lessonPlans.new.durationMatch":
    "Übungsblöcke passen gut zum Stundenrahmen – Puffer für Pausen bleibt eingeplant.",
  "trainer.lessonPlans.new.durationOver":
    "Blöcke sind {count} Min länger als der Stundenrahmen – ggf. straffen oder Rahmen anpassen.",
  "trainer.lessonPlans.new.durationUnder":
    "Noch {count} Min im Stundenrahmen frei – z. B. Trinkpause, Bälle sammeln, Umpumpen.",
  "trainer.lessonPlans.new.form.level": "Level",
  "trainer.lessonPlans.new.form.notes": "Notizen",
  "trainer.lessonPlans.new.form.saveOk": "Unterrichtsplan gespeichert.",
  "trainer.lessonPlans.new.form.title": "Titel",
  "trainer.lessonPlans.new.section.details": "Details",
  "trainer.lessonPlans.new.section.drills": "Übungen",
  "trainer.lessonPlans.new.subtitle":
    "Erstellen Sie einen neuen Unterrichtsplan",
  "trainer.lessonPlans.new.title": "Neuer Unterrichtsplan",
  "trainer.lessonPlans.ai.title": "KI-Stundenvorschlag",
  "trainer.lessonPlans.ai.focusLabel": "Was steht heute an?",
  "trainer.lessonPlans.ai.focusPlaceholder":
    "z. B. Volley-Training für Kindergruppe (8 Jahre), erste Erfahrungen. Am Ende Kontrastspiel: eine Gruppe Volley, andere nach jedem 3. Schlag Lob.",
  "trainer.lessonPlans.ai.generate": "Stunde vorschlagen",
  "trainer.lessonPlans.ai.generating": "KI plant die Stunde…",
  "trainer.lessonPlans.ai.apply": "Vorschlag übernehmen",
  "trainer.lessonPlans.ai.dismiss": "Verwerfen",
  "trainer.lessonPlans.ai.hint":
    "Die KI wählt ausschließlich aus dem Übungskatalog – mit Prüfung von Spieleranzahl, Level, Dauer und Metadaten. Wähle ein Prompt-Template oder passe den Text an.",
  "trainer.lessonPlans.ai.promptAgentLabel": "Prompt-Agent / Vorlage",
  "trainer.lessonPlans.ai.promptUserRulesLabel":
    "Eigene Planungsregeln (optional)",
  "trainer.lessonPlans.ai.promptUserRulesPlaceholder":
    "z. B. Keine Doppelformationen. Max. 2 Kinder gleichzeitig am Netz.",
  "trainer.lessonPlans.ai.promptSaveUserRules": "Eigene Regeln speichern",
  "trainer.lessonPlans.ai.promptUserExtensionTitle": "Eigene Ergänzung",
  "trainer.lessonPlans.ai.rationaleTitle": "Aufbau-Logik",
  "trainer.lessonPlans.ai.previewBlocks":
    "{count} Blöcke · ca. {minutes} Min Übungszeit",
  "trainer.lessonPlans.ai.error.focusRequired":
    "Bitte kurz beschreiben, worum es in der Stunde geht.",
  "trainer.lessonPlans.ai.error.noDrills":
    "Keine passenden Übungen für dieses Level im Katalog.",
  "trainer.lessonPlans.ai.error.emptySuggestion":
    "KI konnte keinen Stundenvorschlag erstellen.",
  "trainer.level.advanced": "Leistung",
  "trainer.level.all": "Alle",
  "trainer.level.beginner": "Anfänger",
  "trainer.level.intermediate": "Fortgeschritten",
  "trainer.level.prof": "Profis",
  "trainer.drills.coverage.title": "Abdeckung nach Tags",
  "trainer.drills.coverage.summary": "Katalog-Abdeckung (optional)",
  "trainer.drills.coverage.hint":
    "Zeigt, wie viele Übungen pro Tag existieren. Klick filtert die Liste.",
  "trainer.drills.coverage.count": "{count} Übungen",
  "trainer.drills.filter.advanced": "Erweiterte Filter",
  "trainer.drills.filter.reset": "Filter zurücksetzen",
  "trainer.drills.filter.level": "Level",
  "trainer.drills.filter.difficulty": "Schwierigkeit",
  "trainer.drills.filter.tag": "Tag",
  "trainer.drills.card.tagsMore": "+{count}",
  "trainer.drills.ai.generate": "Inhalt mit KI erstellen",
  "trainer.drills.ai.generating": "KI erstellt Inhalt…",
  "trainer.drills.ai.hint":
    "Erzeugt Kurzbeschreibung, Variationen, Coaching-Tipps und didaktische Ausarbeitung basierend auf Titel und Metadaten.",
  "trainer.drills.ai.error.titleRequired": "Bitte zuerst einen Titel eingeben.",

  "trainer.drills.pedagogy.title": "Didaktische Ausarbeitung",
  "trainer.drills.pedagogy.empty":
    "Noch nicht ausgearbeitet. Bearbeiten und „Inhalt mit KI erstellen“ nutzen.",
  "trainer.drills.pedagogy.selectPlaceholder": "Bitte wählen",
  "trainer.drills.pedagogy.unterrichtsplanung.title": "Unterrichtsplanung",
  "trainer.drills.pedagogy.zielsetzung.title": "Zielsetzung",
  "trainer.drills.pedagogy.zielsetzung.hint":
    "Konkrete Teilziele, Bezug zur Stunde, aufeinander aufgebaute Trainingsformen.",
  "trainer.drills.pedagogy.gruppe.title": "Beschreibung der Gruppe",
  "trainer.drills.pedagogy.gruppe.hint":
    "Rahmenbedingungen (Plätze, Zeit), Alter, Zusammensetzung, Können, Spielerfahrung, Erwartungen.",
  "trainer.drills.pedagogy.problemlage.title": "Problemlage",
  "trainer.drills.pedagogy.problemlage.hint":
    "Beobachtete Probleme oder Schwierigkeiten.",
  "trainer.drills.pedagogy.methodischePrinzipien.title":
    "Methodische Prinzipien für den Unterrichtsaufbau",
  "trainer.drills.pedagogy.methodischePrinzipien.hint":
    "Welche Prinzipien? Gliederung der Inhalte/Teilziele.",
  "trainer.drills.pedagogy.lehrmethode.title": "Lehrmethode",
  "trainer.drills.pedagogy.lehrmethode.hint":
    "Empfohlenes Lehrverfahren für diese Übung.",
  "trainer.drills.pedagogy.lehrmethode.deduktiv": "Deduktiv (Anweisungslernen)",
  "trainer.drills.pedagogy.lehrmethode.induktiv": "Induktiv (Aufgabenlernen)",
  "trainer.drills.pedagogy.lehrmethode.kombiniert": "Kombiniert",
  "trainer.drills.pedagogy.methodischesVerfahren.title":
    "Methodisches Verfahren",
  "trainer.drills.pedagogy.methodischesVerfahren.hint":
    "Gewähltes Verfahren und Kennzeichnung.",
  "trainer.drills.pedagogy.methodischeKonzeption.title":
    "Methodische Konzeption",
  "trainer.drills.pedagogy.methodischeKonzeption.hint":
    "Konzeption(en), methodische Maßnahmen und Traineraufgaben.",
  "trainer.drills.pedagogy.durchfuehrungsorganisation.title":
    "Überlegungen zur Durchführungsorganisation",
  "trainer.drills.pedagogy.durchfuehrungsorganisation.hint":
    "Organisation für Vorbereitung, Hauptteil und Ausklang; Aufstellungsformen, Trainerposition.",
  "trainer.drills.pedagogy.methodischeHilfsmittel.title":
    "Einsatz methodischer Hilfsmittel",
  "trainer.drills.pedagogy.methodischeHilfsmittel.hint":
    "Welche Hilfsmittel werden eingesetzt und warum?",
  "trainer.drills.pedagogy.lehrmethodik.title": "Lehrmethodik – Verfahren",
  "trainer.drills.pedagogy.lehrverfahrenZielsetzung.title":
    "Zielsetzung Lehrverfahren",
  "trainer.drills.pedagogy.lehrverfahrenZielsetzung.hint":
    "Wann deduktiv (Anweisungslernen), wann induktiv (Aufgabenlernen)? Passung zur Zielgruppe.",
  "trainer.drills.pedagogy.deduktivSchritte.title":
    "Deduktives Lehrverhalten (8 Schritte)",
  "trainer.drills.pedagogy.deduktivSchritte.hint":
    "Information → Demonstration → Bewegungsanweisung → Organisation → Erproben → Korrektur → Variationen → Steigerung.",
  "trainer.drills.pedagogy.deduktivPraxisbeispiel.title":
    "Praxisbeispiel deduktiv",
  "trainer.drills.pedagogy.deduktivPraxisbeispiel.hint":
    "Organisation der Übung und Zuordnung zu den 8 deduktiven Schritten (Technik- oder Taktiktraining).",
  "trainer.drills.pedagogy.induktivSchritte.title":
    "Induktives Lehrverhalten (7 Schritte)",
  "trainer.drills.pedagogy.induktivSchritte.hint":
    "Aufgabenstellung → Ausprobieren → Lenken ohne Korrektur → günstige Lösungen → Nachahmen → Demonstration → neue Aufgabe.",
  "trainer.drills.pedagogy.induktivPraxisbeispiel.title":
    "Praxisbeispiel induktiv",
  "trainer.drills.pedagogy.induktivPraxisbeispiel.hint":
    "Organisation, Variationen und Zuordnung zu den 7 induktiven Schritten.",
  "trainer.drills.pedagogy.insertTemplate": "Schritte-Vorlage",
  "trainer.drills.card.variationsToggle": "Variationen anzeigen",
  "trainer.drills.card.tipsToggle": "Coaching-Tipps anzeigen",
  "trainer.nav.aria": "Trainer Studio Navigation",
  "trainer.nav.breadcrumbAria": "Brotkrumen",
  "trainer.nav.billing": "Abrechnung",
  "trainer.nav.closeSheet": "Schließen",
  "trainer.nav.dashboard": "Übersicht",
  "trainer.nav.dashboardShort": "Übersicht",
  "trainer.nav.drills": "Übungen",
  "trainer.nav.drillsShort": "Übungen",
  "trainer.nav.lessonPlans": "Unterrichtspläne",
  "trainer.nav.lessonPlansShort": "Pläne",
  "trainer.nav.rahmenplanTemplates": "Trainingsrahmen",
  "trainer.nav.rahmenplanTemplatesShort": "Rahmen",
  "trainer.nav.level.main": "Bereich",
  "trainer.nav.sessions": "Stunden",
  "trainer.nav.sessionsShort": "Stunden",
  "trainer.nav.settings": "Einstellungen",
  "trainer.nav.students": "Schüler",
  "trainer.nav.studentsShort": "Schüler",
  "trainer.sessions.detail.blocks.addFromPlan":
    "Blöcke aus Unterrichtsplan übernehmen",
  "trainer.sessions.detail.blocks.completed": "Erledigt",
  "trainer.sessions.detail.blocks.empty": "Noch keine Blöcke dokumentiert.",
  "trainer.sessions.detail.blocks.title": "Ablauf / Blöcke",
  "trainer.sessions.detail.contentSummary": "Was wurde gemacht?",
  "trainer.sessions.detail.markCompleted": "Als durchgeführt markieren",
  "trainer.sessions.detail.progress.empty": "Keine Fortschrittsnotizen.",
  "trainer.sessions.detail.progress.focus": "Schwerpunkte",
  "trainer.sessions.detail.progress.nextSteps": "Nächste Schritte",
  "trainer.sessions.detail.progress.notes": "Fortschritt",
  "trainer.sessions.detail.saveOk": "Dokumentation gespeichert.",
  "trainer.sessions.detail.section.documentation": "Dokumentation",
  "trainer.sessions.detail.section.info": "Informationen",
  "trainer.sessions.detail.section.plan": "Unterrichtsplan",
  "trainer.sessions.detail.section.progress": "Spieler-Fortschritt",
  "trainer.sessions.detail.section.students": "Teilnehmer",
  "trainer.sessions.detail.subtitle":
    "Ansicht und Bearbeitung der Trainerstunde",
  "trainer.sessions.detail.title": "Trainerstunde Details",
  "trainer.sessions.detail.trainerNotes": "Trainer-Notizen",
  "trainer.sessions.list.section.past": "Vergangene Stunden",
  "trainer.sessions.list.section.upcoming": "Anstehende Stunden",
  "trainer.sessions.list.subtitle": "Verwalten Sie Ihre Studio-Sessions",
  "trainer.sessions.list.title": "Studio-Sessions",
  "trainer.sessions.new.form.date": "Datum",
  "trainer.sessions.new.form.duration": "Dauer (Min.)",
  "trainer.sessions.new.form.lessonPlan": "Unterrichtsplan",
  "trainer.sessions.new.form.lessonPlanNone": "Kein Plan",
  "trainer.sessions.new.form.saveOk": "Trainingsstunde angelegt.",
  "trainer.sessions.new.form.students": "Teilnehmer",
  "trainer.sessions.new.form.title": "Titel",
  "trainer.sessions.new.section.details": "Details",
  "trainer.sessions.new.section.students": "Schüler",
  "trainer.sessions.new.subtitle": "Erstellen Sie eine neue Trainerstunde",
  "trainer.sessions.new.title": "Neue Trainerstunde",
  "trainer.sessions.participant.attendance.absent": "Abwesend",
  "trainer.sessions.participant.attendance.planned": "Geplant",
  "trainer.sessions.participant.attendance.present": "Anwesend",
  "trainer.sessions.plan.section.available": "Verfügbare Pläne",
  "trainer.sessions.plan.section.selected": "Ausgewählter Plan",
  "trainer.sessions.plan.subtitle":
    "Weisen Sie dieser Stunde einen Unterrichtsplan zu",
  "trainer.sessions.plan.title": "Unterrichtsplan zuweisen",
  "trainer.sessions.status.cancelled": "Abgesagt",
  "trainer.sessions.status.completed": "Durchgeführt",
  "trainer.sessions.status.planned": "Geplant",
  "trainer.settings.section.appearance": "Erscheinungsbild",
  "trainer.settings.section.notifications": "Benachrichtigungen",
  "trainer.settings.section.profile": "Profil",
  "trainer.settings.subtitle": "Verwalten Sie Ihre Einstellungen",
  "trainer.settings.title": "Einstellungen",
  "trainer.students.detail.noSessions":
    "Noch keine dokumentierten Trainingsstunden.",
  "trainer.students.detail.section.history": "Trainingsverlauf",
  "trainer.students.detail.section.info": "Informationen",
  "trainer.students.detail.section.profile": "Profil",
  "trainer.students.detail.section.progress": "Fortschritt",
  "trainer.students.detail.section.sessions": "Trainerstunden",
  "trainer.students.detail.subtitle":
    "Ansicht und Bearbeitung des Schülerprofils",
  "trainer.students.detail.title": "Schüler Details",
  "trainer.students.form.birthYear": "Geburtsjahr",
  "trainer.students.form.firstName": "Vorname",
  "trainer.students.form.goals": "Ziele",
  "trainer.students.form.isActive": "Aktiv",
  "trainer.students.form.lastName": "Nachname",
  "trainer.students.form.level": "Level",
  "trainer.students.form.profileNotes": "Profilnotizen",
  "trainer.students.form.saveOk": "Schüler gespeichert.",
  "trainer.students.list.section.active": "Aktive Schüler",
  "trainer.students.list.section.inactive": "Inaktive Schüler",
  "trainer.students.list.subtitle": "Verwalten Sie Ihre Schüler",
  "trainer.students.list.subtitleDesk":
    "Spieler aus dem TrainingsDesk – durchsuchbar wie in den Kontakten",
  "trainer.students.list.emptyDesk": "Keine Schüler im TrainingsDesk gefunden.",
  "trainer.students.list.openInDesk": "Im TrainingsDesk anlegen",
  "trainer.students.list.results.one": "{count} Schüler",
  "trainer.students.list.results.other": "{count} Schüler",
  "trainer.students.list.title": "Schüler",
  "trainer.students.new.subtitle": "Schülerprofil anlegen",
  "trainer.students.new.title": "Neuer Schüler",
  "trainer.rahmenplanTemplates.list.title": "Rahmenplan-Vorlagen",
  "trainer.rahmenplanTemplates.list.subtitle":
    "Saison-Schwerpunkte für Serientermine anlegen und bearbeiten – nutzbar in Serienterminen.",
  "trainer.rahmenplanTemplates.list.empty":
    "Noch keine Vorlagen. Lege eine an oder kopiere die U12-Medenspiel-Vorlage.",
  "trainer.rahmenplanTemplates.list.cellCount": "{{count}} Sessions",
  "trainer.rahmenplanTemplates.copyU12": "U12-Vorlage kopieren",
  "trainer.rahmenplanTemplates.new.title": "Neue Rahmenplan-Vorlage",
  "trainer.rahmenplanTemplates.edit.title": "Rahmenplan-Vorlage bearbeiten",
  "trainer.rahmenplanTemplates.notFound": "Vorlage nicht gefunden.",
  "trainer.rahmenplanTemplates.deleteConfirm":
    "Diese Rahmenplan-Vorlage wirklich löschen?",
  "trainer.rahmenplanTemplates.addCell": "Session hinzufügen",
  "trainer.rahmenplanTemplates.sessionLabel": "Session {{n}}",
  "trainer.rahmenplanTemplates.sessionWithMonth": "Session {{n}} · {{month}}",
  "trainer.rahmenplanTemplates.milestoneLine": "{{day}}. {{month}}:",
  "trainer.rahmenplanTemplates.field.title": "Titel",
  "trainer.rahmenplanTemplates.field.description": "Beschreibung",
  "trainer.rahmenplanTemplates.field.cells": "Sessions / Schwerpunkte",
  "trainer.rahmenplanTemplates.field.cellsHint":
    "Die Reihenfolge entspricht Session 1, 2, … – beim Übernehmen in Serientermine wird Session 1 dem ersten Termin zugeordnet usw. Monat ist nur Orientierung.",
  "trainer.rahmenplanTemplates.field.month": "Monat",
  "trainer.rahmenplanTemplates.field.monthNone": "ohne Monat",
  "trainer.rahmenplanTemplates.field.milestone": "Meilenstein",
  "trainer.rahmenplanTemplates.field.milestoneEnabled": "Meilenstein setzen",
  "trainer.rahmenplanTemplates.field.msAfter": "Nach Session Nr.",
  "trainer.rahmenplanTemplates.field.msDay": "Tag",
  "trainer.rahmenplanTemplates.field.msKind": "Art",
  "trainer.rahmenplanTemplates.field.msLabel": "Bezeichnung",
  "trainer.rahmenplanTemplates.field.msNotes": "Notiz",
  "trainer.rahmenplanTemplates.msKind.decision": "Entscheidung",
  "trainer.rahmenplanTemplates.msKind.note": "Hinweis",
  "trainer.rahmenplanTemplates.focus.schwerpunkt": "Schwerpunkt",
  "trainer.rahmenplanTemplates.focus.technik_taktik": "Technik / Taktik",
  "trainer.rahmenplanTemplates.focus.spielform": "Spielform / Beobachtung",
  "trainer.month.january": "Januar",
  "trainer.month.february": "Februar",
  "trainer.month.march": "März",
  "trainer.month.april": "April",
  "trainer.month.may": "Mai",
  "trainer.month.june": "Juni",
  "trainer.month.july": "Juli",
  "trainer.month.august": "August",
  "trainer.month.september": "September",
  "trainer.month.october": "Oktober",
  "trainer.month.november": "November",
  "trainer.month.december": "Dezember",
};
